import { Col, Form, Input, } from "antd";
import { FC, useState } from "react";
import { PatternFormat } from "react-number-format";

interface GeneralPhoneNumberProps {
  name: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  label?: string;
  rules?: any;
  className?: string;
   inputClassName?:string;
}

const GeneralCardsLastUsageDateInput: FC<GeneralPhoneNumberProps> = (props) => {
  const validatePhoneNumber = (_: any, value: string) => {
    if (value && value.includes("_")&& !value.includes("__/__")) {
      return Promise.reject(new Error("kart numaranin formati geçersiz"));
    }
    
    return Promise.resolve();
  };
  

  return (
    <Col xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
      <Form.Item
        className={props.className}
        label={props.label}
        name={props.name}
        rules={[...(props.rules || []), { validator: validatePhoneNumber }]} // Add custom validator to rules
      >
        <PatternFormat
          format="##/##"
          
          // allowEmptyFormatting
          mask="_"
          className={`rounded !w-full ${props.inputClassName}`}
          customInput={Input}
          required={true}
          placeholder="Yıl/Ay"
         
        />
      </Form.Item>
    </Col>
  );
};

export default GeneralCardsLastUsageDateInput;
